const getAsyncData = () => ({
  type: 'GET_ASYNC_DATA'
})

export default { getAsyncData }
